interface IProps {
  id: string;
  name: string;
  productsCount: number;
  isSelected: boolean;
  onChange: (id: string, isSelected: boolean) => void;
}

export default function Choice({ id, name, productsCount, isSelected, onChange }: IProps) {
  return (
    <label htmlFor={id} className="flex items-center gap-x-2 text-base">
      <input
        type="checkbox"
        id={id}
        name={id}
        onChange={checked => onChange(id, checked.target.checked)}
        defaultChecked={isSelected}
        disabled={productsCount === 0}
      />
      <div className="inline-flex items-baseline gap-x-2 font-normal">
        <span className="text-black">{name}</span>
        <span className="select-none text-gray-500 text-base">({productsCount})</span>
      </div>
    </label>
  );
}
